import { UserPermissions } from '../../utils';

export enum AreaWidgetType {
  SalesOverview = 'SalesOverview',
  MembersOverview = 'MembersOverview',
  ConversionRateOverview = 'ConversionRateOverview',
  QueueCustomerOverview = 'QueueCustomerOverview',
  EfficiencyOverview = 'EfficiencyOverview',
  RfidOverview = 'RfidOverview',
  BudgetPlanOverview = 'BudgetPlanOverview',
  KPIForecastOverview = 'KPIForecastOverview',
}

export const areaWidgets = [
  AreaWidgetType.SalesOverview,
  AreaWidgetType.MembersOverview,
  AreaWidgetType.ConversionRateOverview,
  AreaWidgetType.QueueCustomerOverview,
  AreaWidgetType.EfficiencyOverview,
  AreaWidgetType.RfidOverview,
  AreaWidgetType.BudgetPlanOverview,
  AreaWidgetType.KPIForecastOverview,
];

export const getPermissonToViewAreaWidgets = (
  widgetType: AreaWidgetType,
  userPermissions: UserPermissions,
): boolean => {
  const widgetTypePermissionMap: { [key in AreaWidgetType]: boolean } = {
    [AreaWidgetType.SalesOverview]: userPermissions.salesOverview.canRead,
    [AreaWidgetType.MembersOverview]: userPermissions.membersOverview.canRead,
    [AreaWidgetType.ConversionRateOverview]: userPermissions.conversionRateOverview.canRead,
    [AreaWidgetType.QueueCustomerOverview]: userPermissions.queueAndCustomerOverview.canRead,
    [AreaWidgetType.EfficiencyOverview]: userPermissions.efficiencyOverview.canRead,
    [AreaWidgetType.RfidOverview]: userPermissions.rfidOverview.canRead,
    [AreaWidgetType.BudgetPlanOverview]: userPermissions.budgetAndPlanOverview.canRead,
    [AreaWidgetType.KPIForecastOverview]: userPermissions.kpiTargetsOverview.canRead,
  };

  return widgetTypePermissionMap[widgetType] ?? false;
};

export const getIsAreaWidgetVisible = (params: {
  userPermissions: UserPermissions;
}): { isAreaWidgetVisible: (widgetType: AreaWidgetType) => boolean } => {
  const isAreaWidgetVisible = (widgetType: AreaWidgetType) => {
    const { userPermissions } = params;

    const hasPermissonToView = getPermissonToViewAreaWidgets(widgetType, userPermissions);

    if (!hasPermissonToView) return false;

    return true;
  };

  return { isAreaWidgetVisible };
};
